const MS_PER_DAY = 1000 * 60 * 60 * 24;

/** Whole days from now until `isoDate`. Past dates return <= 0. `null` if unusable. */
export const daysUntilExpiry = (
  isoDate: string | null | undefined
): number | null => {
  if (!isoDate) return null;
  const expiry = new Date(isoDate).getTime();
  if (Number.isNaN(expiry)) return null;
  return Math.ceil((expiry - Date.now()) / MS_PER_DAY);
};

/**
 * Tailwind "bg + text" classes for the remaining-days buckets, shared by the
 * toolbar badge and the upgrade modal:
 *   >= 22 green, 7-21 orange, <= 6 (incl. expired) red.
 */
export const subscriptionExpiryTone = (daysLeft: number): string => {
  if (daysLeft >= 22) return "bg-green-100 text-green-700";
  if (daysLeft >= 7) return "bg-orange-100 text-orange-700";
  return "bg-red-100 text-red-700";
};

/** Whether the countdown is close enough to warrant a warning icon (orange/red). */
export const isSubscriptionExpiryUrgent = (daysLeft: number): boolean =>
  daysLeft < 22;

/**
 * Days left below which the expiry countdown is worth surfacing at all. Above
 * it there is nothing to warn about yet, so every countdown UI stays silent.
 */
export const SUBSCRIPTION_EXPIRY_WARNING_DAYS = 30;

/**
 * Whether the remaining-days countdown should be shown, i.e. the subscription
 * is inside its final {@link SUBSCRIPTION_EXPIRY_WARNING_DAYS} days. Already
 * expired (<= 0) counts as visible — that is the loudest case of all. Shared by
 * the toolbar badge and the upgrade panel so the two agree on when to speak up.
 */
export const isSubscriptionExpiryVisible = (daysLeft: number): boolean =>
  daysLeft <= SUBSCRIPTION_EXPIRY_WARNING_DAYS;
